export default __webpack_public_path__ + "static/media/gift_voucher.3f3866fe.svg";